import React from "react";
import styled, { keyframes } from "styled-components";

const Div = styled.div`
  .main {
    left: 50%;
    display: flex;
    transform: translate(-50%, -50%);
    position: absolute;
  }

  .main div {
    margin: 5px 5px 5px 5px;
    padding: 5px;
    width: 5px;
    height: 5px;
    background-color: #0066ab;
    border-radius: 50%;
    animation-duration: 0.8s;
    animation-iteration-count: infinite;
  }

  .one {
    animation-name: load-one;
  }

  @keyframes load-one {
    30% {
      transform: translateY(-50%);
    }
  }

  .two {
    animation-name: load-two;
  }

  @keyframes load-two {
    50% {
      transform: translateY(-50%);
    }
  }

  .three {
    animation-name: load-three;
  }

  @keyframes load-three {
    70% {
      transform: translateY(-50%);
    }
  }
`;
const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const CustomLoader = () => {
  return (
    <div style={{ padding: "30px", margin: "20px" }}>
      <Div>
        <div className="main">
          <div className="one"></div>
          <div className="two"></div>
          <div className="three"></div>
        </div>
      </Div>
    </div>
  );
};

export default CustomLoader;
